import MarketingService from '@/services/marketing-service'

export default function () {
  const pendingRoute = MarketingService.getPendingRoute()
  if (pendingRoute) return pendingRoute

  return { name: 'admin:dashboard' }
}
